//@flow
import React from 'react';
import SnacksIndex from '../../SnacksIndex/components/SnacksIndex.react';
import FilterClear from './FilterClear.react';
import { Link } from 'react-router';

import type { List } from 'immutable';
import type CategoriesCollection from '../../Stores/MemberCategories/categoriesCollection';
import type QuoteItemsCollection from '../../Stores/Quote/quoteItemsCollection';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type StockCollection from '../../Stores/Stock/stockCollection';
import type CustomerModel from '../../Stores/Customer/customerModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';
import type { Filter } from '../../Stores/Filters/filtersStoreClass';
import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';

type Props = {
  categories:CategoriesCollection,
  filters:Filter[],
  quote:QuoteModel,
  quoteItems:QuoteItemsCollection,
  quoteTotals:QuoteTotalsModel,
  products:ProductsCollection,
  stock:StockCollection,
  validSkus:?string[],
  customer:CustomerModel,
  stockReminders:List<string>,
  userCountry:string,
  membershipPlan:MembershipPlanModel,
  isOffice?:boolean,
};

function _getFilteredProducts(props:Props) {
  const { filters, validSkus, products } = props;
  if (filters && validSkus && validSkus.length) {
    return products.getFilteredProducts(filters, validSkus);
  }
}

export default function FiltersResult(props:Props) {
  if (!props.products || !props.products.isLoaded()) {
    return null;
  }

  const filteredProducts = _getFilteredProducts(props) || [];

  if (filteredProducts.length) {
    return (
      <SnacksIndex
        products={filteredProducts}
        productsCollection={props.products}
        stock={props.stock}
        quote={props.quote}
        quoteItems={props.quoteItems}
        quoteTotals={props.quoteTotals}
        categories={props.categories}
        customer={props.customer}
        stockReminders={props.stockReminders}
        userCountry={props.userCountry}
        membershipPlan={props.membershipPlan}
        isOffice={props.isOffice}
      />
    );
  }

  return (
    <div className="no-results-filters">
      <p className="text-2">
        Looks like we don’t have any snacks that meet all of those criteria.
      </p>
      <p className="text-2">
        Try changing your filter settings or
        <Link to={'/products'}>
          <FilterClear>{' view all '}</FilterClear>
        </Link>
        of our snacks.
      </p>
    </div>
  );
}
